<!-- Ported from analytics-design/src/components/AnalyticsUtilitiesDashboard.tsx. No <FilterBar/>
     in this design, so no reordering was needed here (unlike every other screen so far).
     SETTE redesign (CLIPPING-598): token-by-token restyle, no logic change. -->
<div class="space-y-6">
	@if (toastMessage) {
	<div class="fixed bottom-5 right-5 z-50 bg-ink text-white px-4 py-3 rounded-[14px] shadow-toast text-xs font-medium flex items-center gap-2">
		<mat-icon class="!w-4 !h-4 !text-base text-positive-soft">check_circle</mat-icon>
		<span>{{ toastMessage }}</span>
	</div>
	}

	<!-- Module Navigation Switcher -->
	<div class="inline-flex bg-surface-gray p-1 rounded-full">
		<button
			type="button"
			(click)="setSection('saved-views')"
			class="flex items-center gap-2 h-9 px-4 rounded-full text-[13px] font-medium transition-colors cursor-pointer"
			[class]="activeSection === 'saved-views' ? 'bg-surface text-ink shadow-[0_1px_3px_rgba(28,29,33,0.10)]' : 'text-ink-muted hover:text-ink'">
			<mat-icon class="!w-4 !h-4 !text-base">bookmark</mat-icon>
			<span>{{ 'ANALYTICS_UTILITIES.SAVED_VIEWS_TAB' | translate: { count: savedViews.length } }}</span>
		</button>
		<button
			type="button"
			(click)="setSection('exports')"
			class="flex items-center gap-2 h-9 px-4 rounded-full text-[13px] font-medium transition-colors cursor-pointer"
			[class]="activeSection === 'exports' ? 'bg-surface text-ink shadow-[0_1px_3px_rgba(28,29,33,0.10)]' : 'text-ink-muted hover:text-ink'">
			<mat-icon class="!w-4 !h-4 !text-base">download</mat-icon>
			<span>{{ 'ANALYTICS_UTILITIES.EXPORTS_TAB' | translate: { count: exportsList.length } }}</span>
		</button>
	</div>

	<!-- SECTION 1: SAVED VIEWS -->
	@if (activeSection === 'saved-views') {
	<div class="space-y-6">
		<div class="bg-surface rounded-2xl border border-line p-5 sm:p-6">
			<div class="flex items-center gap-2">
				<h1 class="page-title">{{ 'ANALYTICS_UTILITIES.SAVED_VIEWS_TITLE' | translate }}</h1>
				<span class="text-xs font-medium px-2 py-0.5 rounded-full bg-blue-tint text-blue">{{ 'ANALYTICS_UTILITIES.LIGHTWEIGHT_CONFIG_BADGE' | translate }}</span>
			</div>
			<p class="text-xs text-ink-subtle mt-1 max-w-2xl">
				{{ 'ANALYTICS_UTILITIES.SAVED_VIEWS_DESC' | translate }}
			</p>
		</div>

		<div class="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
			<div class="flex items-center gap-2">
				<div class="relative">
					<mat-icon class="!w-3.5 !h-3.5 !text-sm text-ink-subtle absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none">search</mat-icon>
					<input
						type="text"
						[placeholder]="'ANALYTICS_UTILITIES.SEARCH_VIEWS_PLACEHOLDER' | translate"
						[(ngModel)]="searchQuery"
						class="bg-surface border border-line-strong text-ink text-xs rounded-full pl-8 pr-3 h-9 focus-visible:outline-2 focus-visible:outline-focus focus-visible:outline-offset-2 font-medium w-44 sm:w-56" />
				</div>
				<select
					[(ngModel)]="screenFilter"
					class="bg-surface border border-line-strong text-ink text-xs rounded-full px-3 h-9 focus-visible:outline-2 focus-visible:outline-focus focus-visible:outline-offset-2 font-medium">
					<option value="all">{{ 'ANALYTICS_UTILITIES.ALL_SCREENS' | translate }}</option>
					@for (entry of screenOptions | keyvalue; track entry.key) {
					<option [value]="entry.key">{{ entry.value }}</option>
					}
				</select>
			</div>
			<span class="caption text-ink-subtle">{{ filteredViews.length }} {{ (filteredViews.length === 1 ? 'ANALYTICS_UTILITIES.VIEW_SINGULAR' : 'ANALYTICS_UTILITIES.VIEW_PLURAL') | translate }}</span>
		</div>

		@if (savedViewsLoading) {
		<div class="bg-surface border border-line rounded-2xl p-10 text-center caption text-ink-subtle">{{ 'ANALYTICS_UTILITIES.LOADING_SAVED_VIEWS' | translate }}</div>
		} @else {
		<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
			@for (view of filteredViews; track view.id) {
			<div class="bg-surface rounded-2xl border border-line p-5 flex flex-col justify-between group relative">
				<div class="space-y-2.5">
					<div class="flex items-start justify-between gap-2">
						<div class="min-w-0">
							<h3 class="item-title text-ink group-hover:text-blue transition-colors truncate">{{ view.title }}</h3>
							<p class="caption text-ink-subtle font-normal mt-0.5">{{ view.location }}</p>
						</div>

						<div class="relative">
							<button
								type="button"
								(click)="toggleMenu(view.id)"
								class="w-8 h-8 rounded-full hover:bg-surface-gray text-ink-subtle hover:text-ink flex items-center justify-center transition-colors cursor-pointer">
								<mat-icon class="!w-4 !h-4 !text-base">more_vert</mat-icon>
							</button>
							@if (openMenuId === view.id) {
							<div class="absolute right-0 mt-1 w-36 bg-surface border border-line rounded-xl shadow-pop z-20 py-1 text-xs">
								<button type="button" (click)="startRename(view)" class="w-full text-left px-3 py-1.5 text-ink-muted hover:bg-surface-gray flex items-center gap-2 cursor-pointer">
									<mat-icon class="!w-3.5 !h-3.5 !text-sm text-ink-subtle">edit</mat-icon>
									<span>{{ 'ANALYTICS_UTILITIES.RENAME' | translate }}</span>
								</button>
								<button type="button" (click)="duplicateView(view)" class="w-full text-left px-3 py-1.5 text-ink-muted hover:bg-surface-gray flex items-center gap-2 cursor-pointer">
									<mat-icon class="!w-3.5 !h-3.5 !text-sm text-ink-subtle">content_copy</mat-icon>
									<span>{{ 'ANALYTICS_UTILITIES.DUPLICATE' | translate }}</span>
								</button>
								<div class="border-t border-line my-1"></div>
								<button type="button" (click)="deleteView(view)" class="w-full text-left px-3 py-1.5 text-negative hover:bg-negative-tint flex items-center gap-2 font-medium cursor-pointer">
									<mat-icon class="!w-3.5 !h-3.5 !text-sm">delete</mat-icon>
									<span>{{ 'BUTTON.DELETE' | translate }}</span>
								</button>
							</div>
							}
						</div>
					</div>

					<div class="flex flex-wrap gap-1.5">
						@for (badge of view.badges; track badge; let i = $index) {
						<span class="text-[10px] font-medium px-2 py-0.5 rounded-full" [class]="badgeClass(badge, i)">{{ badge }}</span>
						}
					</div>
				</div>

				<div class="pt-4 mt-4 border-t border-line flex items-center justify-between gap-2">
					<span class="caption text-ink-subtle truncate">{{ 'ANALYTICS_UTILITIES.UPDATED_AT' | translate: { date: view.updatedAt } }}</span>
					<button
						type="button"
						(click)="openView(view)"
						class="inline-flex items-center gap-1.5 bg-blue-tint hover:bg-blue text-blue hover:text-on-blue font-medium h-8 px-3 rounded-full text-xs transition-colors shrink-0 cursor-pointer">
						<span>{{ 'ANALYTICS_UTILITIES.OPEN_VIEW' | translate }}</span>
						<mat-icon class="!w-3.5 !h-3.5 !text-sm">arrow_forward</mat-icon>
					</button>
				</div>
			</div>
			}
		</div>

		@if (filteredViews.length === 0) {
		<div class="bg-surface border border-dashed border-line-strong rounded-2xl p-10 text-center space-y-3">
			<div class="w-12 h-12 rounded-full bg-surface-blue text-blue flex items-center justify-center mx-auto">
				<mat-icon class="!w-6 !h-6 !text-2xl">bookmark</mat-icon>
			</div>
			<h3 class="item-title text-ink">{{ 'ANALYTICS_UTILITIES.NO_SAVED_VIEWS_TITLE' | translate }}</h3>
			<p class="text-xs text-ink-subtle max-w-sm mx-auto">
				{{ (savedViews.length === 0 ? 'ANALYTICS_UTILITIES.NO_SAVED_VIEWS_EMPTY' : 'ANALYTICS_UTILITIES.NO_SAVED_VIEWS_FILTERED') | translate }}
			</p>
		</div>
		}
		}
	</div>
	}

	<!-- SECTION 2: EXPORTS -->
	@if (activeSection === 'exports') {
	<div class="space-y-6">
		<div class="bg-surface rounded-2xl border border-line p-5 sm:p-6">
			<div class="flex items-center gap-2">
				<h1 class="page-title">{{ 'ANALYTICS_UTILITIES.EXPORTS_TITLE' | translate }}</h1>
				<span class="text-xs font-medium px-2 py-0.5 rounded-full bg-blue-tint text-blue">{{ 'ANALYTICS_UTILITIES.MENTIONS_XLSX_BADGE' | translate }}</span>
			</div>
			<p class="text-xs text-ink-subtle mt-1 max-w-2xl">
				{{ 'ANALYTICS_UTILITIES.EXPORTS_DESC' | translate }}
			</p>
		</div>

		<div class="p-3.5 rounded-xl bg-warning-tint text-warning flex items-start gap-3">
			<mat-icon class="!w-4 !h-4 !text-base shrink-0 mt-0.5">warning</mat-icon>
			<div class="text-xs leading-relaxed">
				<span class="font-medium">{{ 'ANALYTICS_UTILITIES.ROW_LIMIT_LABEL' | translate }}</span> {{ 'ANALYTICS_UTILITIES.ROW_LIMIT_DESC_PREFIX' | translate }}
				<strong class="underline font-medium">{{ 'ANALYTICS_UTILITIES.ROW_LIMIT_COUNT' | translate }}</strong> {{ 'ANALYTICS_UTILITIES.ROW_LIMIT_DESC_SUFFIX' | translate }}
			</div>
		</div>

		<div class="bg-surface rounded-2xl border border-line overflow-hidden">
			<div class="p-4 sm:px-6 border-b border-line">
				<h2 class="section-title">{{ 'ANALYTICS_UTILITIES.RECENT_EXPORTS_TITLE' | translate }}</h2>
				<p class="text-xs text-ink-subtle">{{ 'ANALYTICS_UTILITIES.RECENT_EXPORTS_DESC' | translate }}</p>
			</div>

			@if (exportsLoading) {
			<div class="p-10 text-center caption text-ink-subtle">{{ 'ANALYTICS_UTILITIES.LOADING_EXPORTS' | translate }}</div>
			} @else {
			<div class="overflow-x-auto">
				<table class="w-full text-left border-collapse text-xs">
					<thead>
						<tr class="bg-page border-b border-line overline-label text-ink-subtle">
							<th class="h-10 px-4 sm:px-6">{{ 'ANALYTICS_UTILITIES.TABLE_DATE' | translate }}</th>
							<th class="h-10 px-3">{{ 'ANALYTICS_FILTER_BAR.PERIOD_LABEL' | translate }}</th>
							<th class="h-10 px-3">{{ 'ANALYTICS_FILTER_BAR.FILTERS_BUTTON' | translate }}</th>
							<th class="h-10 px-3">{{ 'ANALYTICS_UTILITIES.TABLE_ROWS' | translate }}</th>
							<th class="h-10 px-4 sm:px-6 text-right">{{ 'ANALYTICS_UTILITIES.TABLE_ACTION' | translate }}</th>
						</tr>
					</thead>
					<tbody class="font-medium">
						@for (exp of exportsList; track exp.id) {
						<tr class="border-t border-line hover:bg-surface-blue transition-colors">
							<td class="py-3 px-4 sm:px-6 text-ink-subtle">{{ exp.createdAt }}</td>
							<td class="py-3 px-3 text-ink">{{ exp.periodLabel }}</td>
							<td class="py-3 px-3 text-ink-subtle">{{ exp.filterSummary }}</td>
							<td class="py-3 px-3 font-medium text-ink tabular-nums">{{ exp.rowCount }}</td>
							<td class="py-3 px-4 sm:px-6 text-right">
								<button
									type="button"
									(click)="redownloadExport(exp)"
									class="inline-flex items-center gap-1 bg-surface hover:bg-surface-gray text-ink border border-line-strong font-medium h-8 px-2.5 rounded-full text-xs transition-colors cursor-pointer">
									<mat-icon class="!w-3.5 !h-3.5 !text-sm text-ink-subtle">download</mat-icon>
									<span>{{ 'ANALYTICS_UTILITIES.RE_DOWNLOAD' | translate }}</span>
								</button>
							</td>
						</tr>
						}
					</tbody>
				</table>
			</div>
			@if (exportsList.length === 0) {
			<div class="p-10 text-center caption text-ink-subtle">{{ 'ANALYTICS_UTILITIES.NO_EXPORTS_YET' | translate }}</div>
			}
			}
		</div>
	</div>
	}

	<!-- MODAL 1: RENAME VIEW -->
	@if (renameModalOpen) {
	<div class="fixed inset-0 z-50 bg-ink/60 backdrop-blur-xs flex items-center justify-center p-4">
		<div class="bg-surface rounded-2xl shadow-pop border border-line w-full max-w-sm overflow-hidden">
			<div class="px-6 py-4 border-b border-line flex items-center justify-between bg-page">
				<h3 class="item-title text-ink">{{ 'ANALYTICS_UTILITIES.RENAME_VIEW_TITLE' | translate }}</h3>
				<button type="button" (click)="closeRenameModal()" class="w-8 h-8 rounded-full hover:bg-surface-gray text-ink-subtle hover:text-ink flex items-center justify-center transition-colors cursor-pointer">
					<mat-icon class="!w-4 !h-4 !text-base">close</mat-icon>
				</button>
			</div>

			<form (ngSubmit)="submitRename()" class="p-6 space-y-4 text-xs">
				<div>
					<label class="block text-xs font-medium text-ink mb-1">{{ 'ANALYTICS_FILTER_BAR.VIEW_NAME_LABEL' | translate }} <span class="text-negative">*</span></label>
					<input
						type="text"
						required
						cdkFocusInitial
						[(ngModel)]="renameValue"
						name="renameValue"
						class="w-full bg-surface border border-line-strong rounded-xl px-3 py-2 text-xs text-ink focus-visible:outline-2 focus-visible:outline-focus focus-visible:outline-offset-2 font-medium" />
				</div>

				<div class="pt-3 border-t border-line flex items-center justify-end gap-2">
					<button type="button" (click)="closeRenameModal()" class="h-10 px-[18px] border border-line-strong hover:bg-surface-gray text-ink font-medium rounded-full transition-colors cursor-pointer">
						{{ 'BUTTON.CANCEL' | translate }}
					</button>
					<button type="submit" [disabled]="!renameValue.trim()" class="h-10 px-[18px] bg-blue hover:bg-blue-hover text-on-blue font-medium rounded-full transition-colors cursor-pointer disabled:opacity-50">{{ 'BUTTON.SAVE' | translate }}</button>
				</div>
			</form>
		</div>
	</div>
	}

</div>
